import { render } from "./ItemTable.vue?vue&type=template&id=3fd3142e&scoped=true"
import script from "./ItemTable.vue?vue&type=script&lang=js"
export * from "./ItemTable.vue?vue&type=script&lang=js"

import "./ItemTable.vue?vue&type=style&index=0&id=3fd3142e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd3142e"]])

export default __exports__